import { Box } from '@mui/material'
import { FC, Fragment } from 'react'

import type { EventMarker } from '../../data/source'
import { EventMarkerIcon } from '../atoms/EventMarkerIcon'
import { FlowArrow } from '../atoms/FlowArrow'
import { useMarkerLabel } from './useMarkerLabel'

/**
 * A scale's events on the list, in the order of its timeline (see
 * `eventMarkers`): a circle per berth stay with its muelle, each followed by
 * the MARPOL/BOMBEO events that start during it, joined by arrows.
 */
export const ScaleEventMarkers: FC<{ markers: EventMarker[] }> = ({ markers }) => {
  const label = useMarkerLabel()
  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" gap={0.5} data-testid="event-markers">
      {markers.map((marker, index) => (
        <Fragment key={marker.id}>
          {index > 0 && <FlowArrow />}
          <EventMarkerIcon marker={marker} label={label(marker)} />
        </Fragment>
      ))}
    </Box>
  )
}
